import { FC } from 'react';
import { faPhone } from '@fortawesome/pro-regular-svg-icons';

import RcsSectionBlock from './RcsSectionBlock';
import InfoItem from './InfoItem';
import InfoItemLayout from './InfoItemLayout';
import { CampaignDetail } from '@/apis/core/types';

interface TechnicalContactSectionProps {
  campaign?: CampaignDetail;
  isRedacted: boolean;
}

const TechnicalContactSection: FC<TechnicalContactSectionProps> = ({
  campaign,
  isRedacted,
}) => {
  return (
    <RcsSectionBlock
      icon={faPhone}
      title="Technical Contact"
      showDivider={true}
    >
      <InfoItemLayout.Vertical>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Name">
            {isRedacted
              ? 'Redacted due to PII'
              : campaign?.technicalContactName}
          </InfoItem>
          <InfoItem title="Job Title">
            {isRedacted
              ? 'Redacted due to PII'
              : campaign?.technicalContactJobTitle}
          </InfoItem>
        </InfoItemLayout.Horizontal>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Email">
            {isRedacted
              ? 'Redacted due to PII'
              : campaign?.technicalContactEmail}
          </InfoItem>
        </InfoItemLayout.Horizontal>
      </InfoItemLayout.Vertical>
    </RcsSectionBlock>
  );
};

export default TechnicalContactSection;
